import React from "react";
import {Mutation, Query} from "react-apollo";
import queries from "../../../queries";
import {FormattedMessage} from "react-intl";
import FileUploader from "../../uploaders/FileUploader";
import {withRouter} from "react-router-dom";
import PaletteColorPicker from "../../PaletteColorPicker";
import { stateOrValue } from "../../../utils";

class PlanCellEditor extends React.Component  {

  state = {
    i18n: {},
    colorBackground : this.props.cell.background_color,
    textColor: this.props.cell.text_form_color,
    selectedColor: this.props.cell.btn_select_color,
    borderColor: this.props.cell.border_form_color,
    background_left : this.props.cell.background_btn_left,
    background_right : this.props.cell.background_btn_right,
    color_left : this.props.cell.color_text_left,
    color_right : this.props.cell.color_text_right,
    isChange: false,
  };

  setI18nState(language, oldState, newState) {
    this.setState({i18n: {...this.state.i18n, [language.code]: {...oldState, ...newState}}});
  }

  render() {
    const { cell } = this.props;

    const {projectId} = this.props.match.params;

    return (
      <Query query={queries.cells.plan.get} variables={{ id: cell.id }}>
        {({ loading, error, data }) => {
         console.log("Loading:", loading);
         console.log("Error:", error);
         console.log("Data:", data);
   
         if (loading) return null;
         if (error) return `Error!: ${error}`;
   
         const { planCell } = data;
         console.log("PlanCell:", planCell);
   
         if (!planCell) return null;

         if((planCell.background_color !== this.state.background_color || 
            planCell.text_form_color !== this.state.text_form_color ||
            planCell.btn_select_color !== this.state.btn_select_color ||
            planCell.background_btn_left !== this.state.background_btn_left ||
            planCell.background_btn_right !== this.state.background_btn_right ||
            planCell.border_form_color !== this.state.border_form_color ||
            planCell.color_text_left !== this.state.color_text_left ||
            planCell.color_text_right !== this.state.color_text_right) && !this.state.isChange){
          this.setState({
            background_color : planCell.background_color,
            text_form_color: planCell.text_form_color,
            btn_select_color: planCell.btn_select_color,
            border_form_color: planCell.border_form_color,
            background_btn_left : planCell.background_btn_left,
            background_btn_right : planCell.background_btn_right,
            color_text_left : planCell.color_text_left,
            color_text_right : planCell.color_text_right,
            selected_color: planCell.selected_color,
            isChange: true
          });
        };
          return (
            <Mutation
              mutation={queries.cells.plan.update}
              refetchQueries={() => [{ query: queries.cells.plan.get, variables: {id: cell.id} }]}
            >
              {(mutationFct) => (
                <Query query={queries.projects.getWithChildren} variables={{ id: projectId }}>
                {
                  ({ loading, error, data }) => {
                    const {project} = data;
                    if (loading) return null;
                    if (error) return `Error!: ${error}`;
                    return(
                      <div>
                      <label>
                        <FormattedMessage id={"plan.edit.label.gltf"}></FormattedMessage>
                      </label>
                      <FileUploader accept={'.gltf, .glb'} uploadPath='/gltf/' onUpload={(plan) => {
                            const data = plan;
                            mutationFct({ variables: { input:{id: cell.id, plan_uri: data} } });
                          }}>
                      </FileUploader>
                      <br/>
                      <br/>
                      <label>
                        <FormattedMessage id={"plan.edit.label.csv"}></FormattedMessage>
                      </label>
                      <FileUploader cellId={cell.id} accept={'.csv'} uploadPath='/csv_expo/' onUpload={(plan) => {
                            const data = plan;
                            mutationFct({ variables: { input:{id: cell.id, plan_uri: data} } });
                          }}>
                      </FileUploader>
                      <br/>
                      <br/>
                      <label>
                        <FormattedMessage id={'plan.edit.label.background'}/>
                      </label>
                      <PaletteColorPicker
                        color={stateOrValue(this.state.background_color, planCell.background_color)}
                        disableAlpha={true}
                        palette={project.color_palette}
                        onChange={(color) => {
                        const rgb = color.rgb;
                        this.setState({background_color : `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`, isChange: true});
                      }}
                      />
                      <br/>
                      <br/>
                      <label>
                        <FormattedMessage id={'plan.edit.label.text'}/>
                      </label>
                      <PaletteColorPicker
                        color={stateOrValue(this.state.text_form_color, planCell.text_form_color)}
                        disableAlpha={true}
                        palette={project.color_palette}
                        onChange={(color) => {
                        const rgb = color.rgb;
                        this.setState({text_form_color : `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`, isChange: true});
                      }}
                      />
                      <br/>
                      <br/>
                      <label>
                        <FormattedMessage id={'plan.edit.label.selected'}/>
                      </label>
                      <PaletteColorPicker
                        color={stateOrValue(this.state.btn_select_color, planCell.btn_select_color)}
                        disableAlpha={true}
                        palette={project.color_palette}
                        onChange={(color) => {
                        const rgb = color.rgb;
                        this.setState({btn_select_color : `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`, isChange: true});
                      }}
                      />
                      <br/>
                      <br/>
                      <label>
                        <FormattedMessage id={'plan.edit.label.border'}/>
                      </label>
                      <PaletteColorPicker
                        color={stateOrValue(this.state.border_form_color, planCell.border_form_color)}
                        disableAlpha={true}
                        palette={project.color_palette}
                        onChange={(color) => {
                        const rgb = color.rgb;
                        this.setState({border_form_color : `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`, isChange: true});
                      }}
                      />
                      <br/>
                      <label>
                        <FormattedMessage id={'plan.edit.label.background_expo_number'}/>
                      </label>
                      <PaletteColorPicker
                        color={stateOrValue(this.state.background_btn_left, planCell.background_btn_left)}
                        disableAlpha={true}
                        palette={project.color_palette}
                        onChange={(color) => {
                        const rgb = color.rgb;
                        this.setState({background_btn_left : `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`, isChange: true});
                      }}
                      />
                      <br/>
                      <label>
                        <FormattedMessage id={'plan.edit.label.color_expo_number'}/>
                      </label>
                      <PaletteColorPicker
                        color={stateOrValue(this.state.color_text_left, planCell.color_text_left)}
                        disableAlpha={true}
                        palette={project.color_palette}
                        onChange={(color) => {
                        const rgb = color.rgb;
                        this.setState({color_text_left : `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`, isChange: true});
                      }}
                      />
                      <br/>
                      <label>
                        <FormattedMessage id={'plan.edit.label.background_expo_hall'}/>
                      </label>
                      <PaletteColorPicker
                        color={stateOrValue(this.state.background_btn_right, planCell.background_btn_right)}
                        disableAlpha={true}
                        palette={project.color_palette}
                        onChange={(color) => {
                        const rgb = color.rgb;
                        this.setState({background_btn_right : `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`, isChange: true});
                      }}
                      />
                      <br/>
                      <label>
                        <FormattedMessage id={'plan.edit.label.color_expo_hall'}/>
                      </label>
                      <PaletteColorPicker
                        color={stateOrValue(this.state.color_text_right, planCell.color_text_right)}
                        disableAlpha={true}
                        palette={project.color_palette}
                        onChange={(color) => {
                        const rgb = color.rgb;
                        this.setState({color_text_right : `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`, isChange: true});
                      }}
                      />
                      <br/>
                      <br/>
                      <br/>
                      <button className="tsk-button" onClick={()=>{mutationFct({variables: {input:{       
                      id: cell.id,
                      color_text_left: this.state.color_text_left,
                      color_text_right: this.state.color_text_right,
                      background_btn_left: this.state.background_btn_left,
                      background_btn_right: this.state.background_btn_right,
                      background_color: this.state.background_color,
                      text_form_color: this.state.text_form_color,
                      border_form_color: this.state.border_form_color,
                      btn_select_color: this.state.btn_select_color}}}); console.log(this.state)}}>
                        <FormattedMessage id={'common.button.submit'}/>
                      </button>
                    </div>
                    )
                  }
                }
                </Query>
              )}
            </Mutation>
          )
        }}
      </Query>
    );
  }
}

export default withRouter(PlanCellEditor);
